module.exports = __webpack_public_path__ + "media/recipes/73-7a620bf1.png";